import request from "@/axios.js";
import { reject, resolve } from "core-js/fn/promise";

export default class Notes {
	/**
	 * Contract class
	 * @param {object} contract - Contract object
	 * @property {number} type - a type.
	 * @property {number} duration - a duration.
	 * @property {Date} startDate - an startDate.
	 * @property {Date} endDate - a endDate.
	 * @property {number} status - a status.
	 * @property {string} detail - a detail.
	 * @property {string} estimate_link - a estimate_link.
	 * @property {string} commentary - a commentary.
	 * @property {number} max_price_netlink - a max_price_netlink.
	 * @property {number} society_id - an society_id.
	 * @property {string} bccgv_link - an bccgv_link.
	 * @property {number} delivery - delivery of the contract
	 */
	constructor(contract) {
		
	}

	/**
	 * Create an object to be used for forms (on creation)
	 * @return {object} contract object
	 */
	// static getFormFields() {
	// 	return {
	// 		type: 0,
	// 		duration: null,
	// 		status: 0,
	// 		creation_date: null,
	// 		startDate: null,
	// 		endDate: 0,
	// 		detail: null,
	// 		estimate_link: null,
	// 		commentary: null,
	// 		max_price_netlink: null,
	// 		society_id: null,
	// 		bccgv_link: null,
	// 		delivery: 0,
	// 		commercial_id: null,
	// 		account_managers: [],
	// 		max_budget: null,
	// 		early_cancellation: 0,
	// 		early_cancellation_duration: 0,
	// 		engagement_duration: null,
	// 		termination_reason_id: 0,
	// 		program_end_date: null
	// 	};
	// }

	
	/**
	 * Get Notes fro user Id
	 * @param {Number} uid 
	 * @returns 
	 */
	static async getForNotes(uid){
		return new Promise((resolve, reject) =>{
			request.get("notes/notesFor/uid?uid=" + uid)
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err);
			});
		} )

	}
	/**
	 * To check or uncheck a note
	 * @param {Number} id 
	 * @param {Boolean} val 
	 * @returns 
	 */
	static async checkNote(id, val){
		return new Promise((resolve, reject) =>{
			request.post("notes/check",{
				id: id,
				notification_checked: val
			})
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err);
			});
		} )

	}
	

}
